import React from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "@material-ui/core";
import DialogModalHeader from "../../../../components/dialogModal/dialogModalHeader";
import { useConnectedAppProps } from "../connectedApps";
import ErrorMessage from "../connectedAppsError";

const RevokeConsent = () => {
  const { appInfo, handleAppAccess, handleClose, appStatus, error } = useConnectedAppProps();

  const {application_name, application_id} = appInfo;

  return (
    <div className="account-modal-body">
      <DialogModalHeader
        title={
          <FormattedMessage
            defaultMessage="Disconnect {app_name}?"
            values={{ app_name: application_name }}
          />
        }
        hide_cancel={true}
      />
      
      {error && <div className="line-break"><ErrorMessage  error={error} /></div>}
  
      <div className="line-break">
        <FormattedMessage
          defaultMessage="Disconnecting access might prevent some {app_name} features from working correctly. If you want to use {app_name} features with your Trimble account, you will need to link your accounts again."
          values={{ app_name: application_name }}
        />
      </div>
    

      <div className="title-bold"><FormattedMessage defaultMessage="What happens to your data"/></div>
      <div style={{ marginTop: "0.5rem" }}><FormattedMessage defaultMessage="Disconnecting this application will not delete data or information shared with {app_name}." 
      values={{ app_name: application_name}}/></div>
      <div>
        <Button
          className="action-button line-break"
          onClick={(e) => handleAppAccess(e, application_id)}
          color="primary"
          disableElevation
          variant="contained"
          disabled={appStatus === "pending_revoke"}
        >
          <FormattedMessage defaultMessage="Disconnect application" />
        </Button>
      
        <Button
          className="outline-button"
          onClick={(e) => handleClose(e)}
          color="primary"
          disableElevation
          variant="outlined"
          disabled={appStatus === "pending_revoke"}
        >
          <FormattedMessage defaultMessage="Cancel" />
        </Button>
      </div>
    </div>
  );
};

export default RevokeConsent;
